import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { AuthService } from '@ubie/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[doesNotHaveClaim]',
    standalone: false
})
export class DoesNotHaveClaimDirective {
  private readonly templateRef = inject<TemplateRef<any>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly securityService = inject(AuthService);

  @Input() set doesNotHaveClaim(claimType: any) {
    if (!this.securityService.hasClaim(claimType)) {
      // Add template to DOM
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      // Remove template from DOM
      this.viewContainer.clear();
    }
  }
}
